// extracted by mini-css-extract-plugin
export default {"navigation-link":"menu-navigation-item_navigation-link__H7yhZ","active":"menu-navigation-item_active__bAlxA"};